import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PublicHoliday } from '../../types/team.types';
import { useAppQuery } from '../use-app-query.hook';

// Cross-tenant admin data (company-wide public holidays): intentionally not scoped to a single
// companyId — access is enforced server-side by AdminPanelGuard, not by the companies/:companyId
// path used by tenant-facing hooks.
export const usePublicHolidays = () => {
  const queryClient = useQueryClient();

  const invalidate = useCallback(
    () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PUBLIC_HOLIDAYS] }),
    [queryClient],
  );

  const { data, isLoading, isError } = useAppQuery<PublicHoliday[]>({
    queryKey: [QueryKey.GET_PUBLIC_HOLIDAYS],
    queryFn: () => ApiService.get({ endpoint: BackendRoute.TEAM_PUBLIC_HOLIDAYS }),
  });

  return { holidays: data ?? [], isLoading, isError, invalidate };
};
